if (!customElements.get('quick-view-modal')) {
  customElements.define(
    'quick-view-modal',
    class QuickViewModal extends DrawerComponent {
      constructor() {
        super();

        this.classesToRemoveOnLoad = 'drawer--loading';
        this.drawerBody = this.querySelector(this.selector);
      }

      get selector() {
        return '.quick-view__content';
      }

      get requiresBodyAppended() {
        return !(Shopify.designMode && this.closest('.section-group-overlay-quick-view'));
      }

      prepareToShow() {
        super.prepareToShow();
        this.quickview();
      }

      handleAfterShow() {
        super.handleAfterShow();
        document.dispatchEvent(
          new CustomEvent('quick-view:open', {
            detail: { productUrl: this.dataset.productUrl }
          })
        );
      }

      handleAfterHide() {
        super.handleAfterHide();
        const drawerContent = this.querySelector(this.selector);
        drawerContent.innerHTML = '';
        this.classList.add(this.classesToRemoveOnLoad);
      }

      getProductQuickViewSectionId() {
        let sectionId = FoxTheme.QuickViewSectionId || false;

        if (!sectionId) {
          // Get section id from overlay groups.
          const productQuickView = document.querySelector('.section-group-overlay-quick-view');
          if (productQuickView) {
            sectionId = FoxTheme.utils.getSectionId(productQuickView);
          }

          // Cache for better performance.
          FoxTheme.QuickViewSectionId = sectionId;
        }

        return sectionId;
      }

      quickview() {
        // Clear content of ALL other quick view modals to prevent conflicts
        document.querySelectorAll('quick-view-modal .quick-view__content').forEach((content) => {
          if (content !== this.querySelector(this.selector)) {
            content.innerHTML = '';
          }
        });

        const drawerContent = this.querySelector(this.selector);
        const sectionId = this.getProductQuickViewSectionId();
        const baseUrl = this.dataset.productUrl.split('?')[0];

        Promise.all([
          fetch(`${baseUrl}?section_id=${sectionId}`).then((res) => res.text()),
          fetch(baseUrl).then((res) => res.text())
        ])
          .then(([quickViewText, mainProductText]) => {
            const quickViewElement = new DOMParser()
              .parseFromString(quickViewText, 'text/html')
              .querySelector(this.selector);

            const mainProductDoc = new DOMParser().parseFromString(mainProductText, 'text/html');
            const mainProductInfo = mainProductDoc.querySelector('.product__info-wrapper');
            const mainProductInfoElement = mainProductDoc.querySelector('product-info');
            const mainSectionId = mainProductInfoElement ? mainProductInfoElement.dataset.section : '';

            if (quickViewElement && mainProductInfo) {
              const quickViewInfo = quickViewElement.querySelector('.product__info-wrapper');
              if (quickViewInfo) {
                let newHtml = mainProductInfo.innerHTML;
                if (mainSectionId && sectionId) {
                  // Replace the main section ID with the quick view section ID in the HTML
                  // so that variant selectors and forms target the correct IDs in the modal
                  newHtml = newHtml.split(mainSectionId).join(sectionId);
                  
                  // Set original section so that product-info.js fetches updates from the main product page
                  const productInfoElement = quickViewElement.querySelector('product-info');
                  if (productInfoElement) {
                    productInfoElement.setAttribute('data-original-section', mainSectionId);
                  }
                }
                quickViewInfo.innerHTML = newHtml;

                // Add 'View Details' link
                const viewDetailsHtml = `
                  <div class="product__view-details" style="margin-top: 1.5rem; padding-bottom: 1rem;">
                    <a href="${this.dataset.productUrl}" class="link" style="color: #00a0af;">
                      View Details
                    </a>
                  </div>
                `;

                // Usually the blocks are inside a container, let's append to the container if it exists, otherwise to the wrapper
                const infoContainer = quickViewInfo.querySelector('.product__info-container');
                if (infoContainer) {
                  infoContainer.insertAdjacentHTML('beforeend', viewDetailsHtml);
                } else {
                  quickViewInfo.insertAdjacentHTML('beforeend', viewDetailsHtml);
                }
              }
            }

            this.setInnerHTML(drawerContent, quickViewElement ? quickViewElement.innerHTML : '');

            FoxTheme.a11y.trapFocus(this, this.focusElement);
            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }

            document.dispatchEvent(
              new CustomEvent('quick-view:loaded', {
                detail: { productUrl: this.dataset.productUrl }
              })
            );
          })
          .catch((e) => {
            console.error(e);
          });
      }

      setInnerHTML(element, innerHTML) {
        // Remove old variant-selects before setting new innerHTML
        const oldVariantSelects = element.querySelectorAll('variant-selects');
        oldVariantSelects.forEach((vs) => vs.remove());

        element.innerHTML = innerHTML;

        element.querySelectorAll('script').forEach((oldScriptTag) => {
          const newScriptTag = document.createElement('script');
          Array.from(oldScriptTag.attributes).forEach((attribute) => {
            newScriptTag.setAttribute(attribute.name, attribute.value);
          });
          newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
          oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
        });

        this.classList.remove(this.classesToRemoveOnLoad);
      }

      setInnerHTML(element, innerHTML) {
        element.innerHTML = innerHTML;
        element.querySelectorAll('script').forEach((oldScriptTag) => {
          const newScriptTag = document.createElement('script');
          Array.from(oldScriptTag.attributes).forEach((attribute) => {
            newScriptTag.setAttribute(attribute.name, attribute.value);
          });
          newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
          oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
        });

        this.classList.remove(this.classesToRemoveOnLoad);
      }
    }
  );
}
